/**
 * Secure Storage Utility
 * 
 * Token storage: sessionStorage (cleared on tab close, not accessible to other tabs)
 * Non-sensitive data (user profile, tenant): localStorage with JSON serialization
 * 
 * This prevents token persistence across sessions and reduces XSS token theft window.
 */

const TOKEN_KEY = 'token';
const USER_KEY = 'user';
const TENANT_KEY = 'tenant';

export const secureStorage = {
  // Token: stored in sessionStorage (ephemeral)
  getToken: () => sessionStorage.getItem(TOKEN_KEY),
  setToken: (token) => {
    if (token) {
      sessionStorage.setItem(TOKEN_KEY, token);
    } else {
      sessionStorage.removeItem(TOKEN_KEY);
    }
  },
  removeToken: () => sessionStorage.removeItem(TOKEN_KEY),

  // User profile: sessionStorage (cleared on close)
  getUser: () => {
    try {
      const data = sessionStorage.getItem(USER_KEY);
      return data ? JSON.parse(data) : null;
    } catch { return null; }
  },
  setUser: (user) => {
    if (user) {
      sessionStorage.setItem(USER_KEY, JSON.stringify(user));
    } else {
      sessionStorage.removeItem(USER_KEY);
    }
  },
  removeUser: () => sessionStorage.removeItem(USER_KEY),

  // Tenant: sessionStorage (cleared on close)  
  getTenant: () => {
    try {
      const data = sessionStorage.getItem(TENANT_KEY);
      return data ? JSON.parse(data) : null;
    } catch { return null; }
  },
  setTenant: (tenant) => {
    if (tenant) {
      sessionStorage.setItem(TENANT_KEY, JSON.stringify(tenant));
    } else {
      sessionStorage.removeItem(TENANT_KEY);
    }
  },
  removeTenant: () => sessionStorage.removeItem(TENANT_KEY),

  // Clear all auth data
  clearAll: () => {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
    sessionStorage.removeItem(TENANT_KEY);
  },
};

export default secureStorage;
